module.exports = __webpack_public_path__ + "img/characteristic-4.4b2e494a.png";